import { NotificationContainer } from 'react-notifications';
import Navigation from './navigation';

import './index.css';
import 'react-notifications/lib/notifications.css';

function App() {
  return (
    <div className="app">
      <NotificationContainer />
      <Navigation />
    </div>
  );
}

export default App;
